//
//
//
//
//

export default {
  props: {
    max: {
      type: Number,
      default: 5
    },
    size: {
      type: Number
    },
    value: {
      default: 0
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/CRater.vue